// extracted by mini-css-extract-plugin
export default {"mainContainer":"Menu_mainContainer__HcuDZ","menuContainer":"Menu_menuContainer__5c7YV"};